const BlogsRoutes = {
  getAllBlogs: "/blogs",
  createBlog: "/blogs/create",
  deleteBlog: "/blogs/delete",
  blogPicture: "/blogs/upload",
  editBlog: "/blogs/update",
}

export default BlogsRoutes